import { useState, lazy, useEffect, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';

import { Layout, LoadingLayout, Loading } from 'common/components/layout';
import { retry } from 'common/helpers/routerHelper';
import { pageFromQueryString } from 'common/helpers/searchHelper';
import { getCollectionBySlug } from 'redux/collections/reducers';
import { listProducts } from 'redux/products/actions';

import { getQString } from './helpers';
import CollectionNotFound from './notFound/CollectionNotFound';

const LoadableComponent = lazy(() => retry(() => import('./Collection')));

const CollectionLoader = () => {
  const [isNotFound, setNotFound] = useState(false);
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const { slug } = params;

  const collectionReducer = useSelector((state) => state.collection);
  const collection = getCollectionBySlug(collectionReducer, slug);

  const qString = getQString(location.search);
  const page = pageFromQueryString(location.search);

  const onError = () => {
    setNotFound(true);
  };

  useEffect(() => {
    dispatch(listProducts(slug, qString, page, onError));
  }, [dispatch, slug, page, qString]);

  // // TODO - Pagination
  if (isNotFound) {
    return <CollectionNotFound />;
  }

  if (
    !collectionReducer.data ||
    collectionReducer.isObjectFetching ||
    !collection
  ) {
    return <LoadingLayout />;
  }

  return (
    <Layout
      title={collection.seo.title}
      description={collection.seo.description}
    >
      <Suspense fallback={<Loading />}>
        <LoadableComponent />
      </Suspense>
    </Layout>
  );
};

export default CollectionLoader;
